import request from '@/utils/request'

// 获取公司开发配置
export function getConfig(params) {
  return request({ url: '/webapi/dev/getConfig', method: 'get', params })
}

// 设置公司开发设置
export function setConfig(data) {
  return request({ url: '/webapi/dev/setConfig', method: 'post', data })
}

// 版本更新-获取版本列表
export const versionList = (params) => {
  return request.get('/webapi/version/versionList', { params })
}

// 消息配置列表
export function noticesetList() {
  return request({ url: '/webapi/notice/noticesetList', method: 'post' })
}

// 设置消息角色
export function setNoticerole(data) {
  return request({ url: '/webapi/notice/setNoticerole', method: 'post', data })
}

// 预警金额
export function getEwconfig(data) {
  return request({ url: '/webapi/dev/getEwconfig', method: 'post', data })
}

// 预警金额配置
export function setEwconfig(data) {
  return request({ url: '/webapi/dev/setEwconfig', method: 'post', data })
}

